import React, { Suspense } from 'react';
import Slider from '../components/Home/Slider';

const AboutUs = React.lazy(() => import('../components/Home/About-us'));
const Services = React.lazy(() => import('../components/Home/Services'));
const CallAction = React.lazy(() => import('../components/Home/Call-action'));
const Specialist = React.lazy(() => import('../components/Home/Specialist'));
const Counters = React.lazy(() => import('../components/Home/Counters'));
const Appointment = React.lazy(() => import('../components/Home/Appointment'));
const Testimonial = React.lazy(() => import('../components/Home/Testimonial'));
// import './Home.css';

const TitleSkeleton = () => (
  <div className="placeholder-glow mb-3">
    <span className="placeholder col-3"></span>
    <span className="placeholder col-6"></span>
  </div>
);

const ParagraphSkeleton = ({ lines = 3 }) => (
  <div className="placeholder-glow">
    {Array.from({ length: lines }).map((_, index) => (
      <span key={index} className="placeholder col-12"></span>
    ))}
  </div>
);

const ImageSkeleton = ({ height = '240px' }) => (
  <div className="placeholder-glow">
    <span className="placeholder col-12" style={{ height }}></span>
  </div>
);

const AboutSkeleton = () => (
  <section className="container py-5">
    <div className="row">
      <div className="col-lg-8 col-md-12">
        <TitleSkeleton />
      </div>
      <div className="col-lg-7 col-md-12">
        {Array.from({ length: 3 }).map((_, index) => (
          <div className="placeholder-glow mb-4" key={index}>
            <span className="placeholder col-2"></span>
            <span className="placeholder col-8"></span>
            <span className="placeholder col-12"></span>
          </div>
        ))}
      </div>
      <div className="col-lg-5 col-md-12">
        <ImageSkeleton height="280px" />
      </div>
    </div>
  </section>
);

const ServicesSkeleton = () => (
  <section className="container py-5">
    <TitleSkeleton />
    <div className="row g-4">
      {Array.from({ length: 6 }).map((_, index) => (
        <div className="col-lg-4 col-md-6" key={index}>
          <div className="placeholder-glow">
            <span className="placeholder col-3"></span>
            <span className="placeholder col-8"></span>
            <span className="placeholder col-12"></span>
          </div>
        </div>
      ))}
      <div className="col-lg-12">
        <div className="placeholder-glow">
          <span className="placeholder col-6"></span>
        </div>
      </div>
    </div>
  </section>
);

const CallActionSkeleton = () => (
  <section className="container py-5">
    <div className="row">
      <div className="col-lg-6 col-md-12">
        <TitleSkeleton />
        <ParagraphSkeleton lines={4} />
        <div className="mt-3">
          <ParagraphSkeleton lines={4} />
        </div>
      </div>
      <div className="col-lg-6 col-md-12">
        <ImageSkeleton height="320px" />
      </div>
    </div>
  </section>
);

const SpecialistSkeleton = () => (
  <section className="specialist icon-right pad-top-0">
    <div className="container">
      <div className="row">
        <div className="col-lg-12">
          <div className="section-title">
            <TitleSkeleton />
          </div>
        </div>
      </div>
      <div className="specialist-slider row">
        {Array.from({ length: 6 }).map((_, index) => (
          <div className="col-lg-3 col-md-6" key={index}>
            <div className="special-main">
              <div className="special-item">
                <div className="special-image">
                  <div className="placeholder-glow">
                    <span className="placeholder col-12" style={{ height: '220px', display: 'block' }}></span>
                  </div>
                  <div className="color-overlay"></div>
                </div>
                <div className="special-content">
                  <div className="placeholder-glow">
                    <span className="placeholder col-8"></span>
                    <span className="placeholder col-5"></span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  </section>
);

const CountersSkeleton = () => (
  <section className="container py-5">
    <div className="row">
      <div className="col-lg-7 col-md-12">
        <TitleSkeleton />
        <div className="row g-3">
          {Array.from({ length: 4 }).map((_, index) => (
            <div className="col-lg-6 col-md-6" key={index}>
              <div className="placeholder-glow">
                <span className="placeholder col-12" style={{ height: '90px' }}></span>
              </div>
            </div>
          ))}
        </div>
      </div>
      <div className="col-lg-5 col-md-12">
        <ImageSkeleton height="260px" />
      </div>
    </div>
  </section>
);

const AppointmentSkeleton = () => (
  <section className="container py-5">
    <div className="row">
      <div className="col-lg-12">
        <div className="text-center">
          <TitleSkeleton />
        </div>
      </div>
    </div>
    <div className="row g-4">
      <div className="col-lg-5 col-md-12">
        <ImageSkeleton height="280px" />
      </div>
      <div className="col-lg-7 col-md-12">
        <div className="row g-3">
          {Array.from({ length: 6 }).map((_, index) => (
            <div className="col-lg-6" key={index}>
              <div className="placeholder-glow">
                <span className="placeholder col-12" style={{ height: '44px' }}></span>
              </div>
            </div>
          ))}
          <div className="col-lg-12">
            <div className="placeholder-glow">
              <span className="placeholder col-12" style={{ height: '120px' }}></span>
            </div>
          </div>
          <div className="col-lg-12">
            <div className="placeholder-glow">
              <span className="placeholder col-4" style={{ height: '44px' }}></span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
);

const TestimonialSkeleton = () => (
  <section className="container py-5">
    <div className="row">
      <div className="col-lg-5 col-md-12">
        <TitleSkeleton />
        <ParagraphSkeleton lines={2} />
        <div className="placeholder-glow mt-3">
          <span className="placeholder col-5" style={{ height: '44px' }}></span>
        </div>
      </div>
      <div className="col-lg-7 col-md-12">
        <div className="placeholder-glow">
          <span className="placeholder col-12" style={{ height: '260px' }}></span>
        </div>
      </div>
    </div>
  </section>
);

const Home = () => {
  return (
    <div className="home-page">
      {/* HERO SECTION */}
      <Slider />
      <Suspense fallback={<AboutSkeleton />}>
        <AboutUs />
      </Suspense>
      <Suspense fallback={<ServicesSkeleton />}>
        <Services />
      </Suspense>
      <Suspense fallback={<CallActionSkeleton />}>
        <CallAction />
      </Suspense>
      <Suspense fallback={<SpecialistSkeleton />}>
        <Specialist />
      </Suspense>
      <Suspense fallback={<CountersSkeleton />}>
        <Counters />
      </Suspense>
      <Suspense fallback={<AppointmentSkeleton />}>
        <Appointment />
      </Suspense>
      <Suspense fallback={<TestimonialSkeleton />}>
        <Testimonial />
      </Suspense>
    </div>
  );
};

export default Home;
